// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2M6kc","row":"styles_row__3NzN-"};